/* Yen Aura cart upsell: ADD-to-cart + arrow/dot switching.
   Uses document-level event delegation so it survives drawer re-renders. */
(function () {
  if (window.__yenUpsellInit) return;
  window.__yenUpsellInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function refreshDrawer(json) {
    if (!json || !json.sections) return;
    var parser = new DOMParser();
    var drawer = document.querySelector('cart-drawer');
    if (json.sections['cart-drawer'] && drawer) {
      var doc = parser.parseFromString(json.sections['cart-drawer'], 'text/html');
      var fresh = doc.querySelector('cart-drawer');
      if (fresh) drawer.innerHTML = fresh.innerHTML;
    }
    if (json.sections['cart-icon-bubble']) {
      var bubble = document.querySelector('#cart-icon-bubble');
      if (bubble) {
        var bdoc = parser.parseFromString(json.sections['cart-icon-bubble'], 'text/html');
        var bfresh = bdoc.querySelector('.shopify-section') || bdoc.body;
        if (bfresh) bubble.innerHTML = bfresh.innerHTML;
      }
    }
    // Note: we intentionally do NOT dispatch the theme's legacy 'cart:update'
    // event. Its gift-threshold handler is unused (settings are blank) and only
    // fired a wasted /cart.js request. BOGOS recalculates gifts on its own.
  }

  function addToCart(btn) {
    var variantId = btn.getAttribute('data-yen-add');
    if (!variantId || btn.classList.contains('is-loading')) return;

    btn.classList.add('is-loading');
    var spinner = btn.querySelector('.yen-upsell__add-spinner');
    if (spinner) spinner.hidden = false;

    function resetButton(soldOut) {
      btn.classList.remove('is-loading');
      if (spinner) spinner.hidden = true;
      if (soldOut) {
        btn.setAttribute('disabled', '');
        var label = btn.querySelector('.yen-upsell__add-label');
        if (label) label.textContent = 'SOLD OUT';
      }
    }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json().then(function (json) { return { ok: r.ok, json: json }; });
      })
      .then(function (res) {
        // A failed add (e.g. sold out / quantity limit) returns HTTP 422 with no
        // sections. Never leave the button spinning — reset it and flag sold out.
        if (!res.ok || !res.json || !res.json.sections) {
          resetButton(!!(res.json && res.json.description));
          return;
        }
        refreshDrawer(res.json);
      })
      .catch(function (err) {
        console.error('Yen upsell add error:', err);
        resetButton(false);
      });
  }

  function setSlide(widget, index) {
    var slides = widget.querySelectorAll('[data-yen-slide]');
    var dots = widget.querySelectorAll('[data-yen-dot]');
    if (!slides.length) return;
    index = (index + slides.length) % slides.length;
    slides.forEach(function (s) {
      s.classList.toggle('is-active', parseInt(s.getAttribute('data-yen-slide'), 10) === index);
    });
    dots.forEach(function (d) {
      d.classList.toggle('is-active', parseInt(d.getAttribute('data-yen-dot'), 10) === index);
    });
    widget.setAttribute('data-current', index);
  }

  function currentIndex(widget) {
    return parseInt(widget.getAttribute('data-current') || '0', 10);
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-yen-add]');
    if (addBtn) { e.preventDefault(); addToCart(addBtn); return; }

    var prev = e.target.closest('[data-yen-prev]');
    if (prev) { var w1 = prev.closest('[data-yen-upsell]'); setSlide(w1, currentIndex(w1) - 1); return; }

    var next = e.target.closest('[data-yen-next]');
    if (next) { var w2 = next.closest('[data-yen-upsell]'); setSlide(w2, currentIndex(w2) + 1); return; }

    var dot = e.target.closest('[data-yen-dot]');
    if (dot) { var w3 = dot.closest('[data-yen-upsell]'); setSlide(w3, parseInt(dot.getAttribute('data-yen-dot'), 10)); return; }
  });
})();
